import { CONNECTOR_CATALOG } from "./catalog.js";
/** Display grouping for planned connectors; independent of CATALOG_CATEGORY_ORDER. */
export const PLANNED_CONNECTOR_CATEGORIES = [
    { key: "microsoft", label: "Microsoft" },
    { key: "chat", label: "Chat" },
    { key: "developer", label: "Developer Tools" },
    { key: "tasks", label: "Issues & Project Tracking" },
    { key: "docs", label: "Docs & Knowledge" },
    { key: "crm", label: "CRM" },
    { key: "support", label: "Customer Support" },
    { key: "scheduling", label: "Scheduling & Meetings" },
    { key: "commerce", label: "Commerce" },
    { key: "marketing", label: "Marketing" },
    { key: "finance", label: "Finance & Accounting" },
    { key: "analytics", label: "Product Analytics" },
    { key: "hr", label: "HR & Payroll" },
];
export const PLANNED_CONNECTORS = [
    // Built — connector module exists, install path pending.
    {
        id: "google_analytics",
        label: "Google Analytics",
        category: "analytics",
        description: "GA4 traffic, acquisition, and conversion reporting.",
        built: true,
    },
    // Wishlist — not built yet; requests tell us what to build next.
    {
        id: "microsoft_teams",
        label: "Microsoft Teams",
        category: "microsoft",
        description: "Channel messages and meeting context.",
    },
    {
        id: "vercel",
        label: "Vercel",
        category: "developer",
        description: "Deployments and preview status.",
    },
    {
        id: "pagerduty",
        label: "PagerDuty",
        category: "developer",
        description: "Incidents and on-call context.",
    },
    {
        id: "monday",
        label: "monday.com",
        category: "tasks",
        description: "Boards and work management.",
    },
    {
        id: "clickup",
        label: "ClickUp",
        category: "tasks",
        description: "Tasks, docs, and goals.",
    },
    {
        id: "dropbox",
        label: "Dropbox",
        category: "docs",
        description: "Shared files and folders as a docs source.",
    },
    {
        id: "box",
        label: "Box",
        category: "docs",
        description: "Enterprise file storage as a docs source.",
    },
    {
        id: "miro",
        label: "Miro",
        category: "docs",
        description: "Boards and workshop artifacts.",
    },
    {
        id: "pipedrive",
        label: "Pipedrive",
        category: "crm",
        description: "Deals and pipeline visibility.",
    },
    {
        id: "attio",
        label: "Attio",
        category: "crm",
        description: "Modern CRM records and lists.",
    },
    {
        id: "close",
        label: "Close",
        category: "crm",
        description: "Leads, calls, and sales activity.",
    },
    {
        id: "front",
        label: "Front",
        category: "support",
        description: "Shared inboxes and customer replies.",
    },
    {
        id: "help_scout",
        label: "Help Scout",
        category: "support",
        description: "Mailboxes and support conversations.",
    },
    {
        id: "cal_com",
        label: "Cal.com",
        category: "scheduling",
        description: "Open-source scheduling and bookings.",
    },
    {
        id: "square",
        label: "Square",
        category: "commerce",
        description: "Payments and point-of-sale revenue.",
    },
    {
        id: "mailchimp",
        label: "Mailchimp",
        category: "marketing",
        description: "Campaigns, audiences, and email performance.",
    },
    {
        id: "klaviyo",
        label: "Klaviyo",
        category: "marketing",
        description: "Ecommerce email and SMS performance.",
    },
    {
        id: "customer_io",
        label: "Customer.io",
        category: "marketing",
        description: "Lifecycle messaging and campaign activity.",
    },
    {
        id: "webflow",
        label: "Webflow",
        category: "marketing",
        description: "Site content and form submissions.",
    },
    {
        id: "typeform",
        label: "Typeform",
        category: "marketing",
        description: "Form and survey responses.",
    },
    {
        id: "quickbooks",
        label: "QuickBooks",
        category: "finance",
        description: "Invoices, expenses, and books visibility.",
    },
    {
        id: "xero",
        label: "Xero",
        category: "finance",
        description: "Accounting and cash-flow visibility.",
    },
    {
        id: "ramp",
        label: "Ramp",
        category: "finance",
        description: "Spend, cards, and expense activity.",
    },
    {
        id: "mercury",
        label: "Mercury",
        category: "finance",
        description: "Banking balances and transactions.",
    },
    {
        id: "amplitude",
        label: "Amplitude",
        category: "analytics",
        description: "Product usage and funnel metrics.",
    },
    {
        id: "mixpanel",
        label: "Mixpanel",
        category: "analytics",
        description: "Event analytics and retention metrics.",
    },
    {
        id: "posthog",
        label: "PostHog",
        category: "analytics",
        description: "Product analytics, flags, and session context.",
    },
    {
        id: "segment",
        label: "Segment",
        category: "analytics",
        description: "Customer data pipeline visibility.",
    },
    {
        id: "gusto",
        label: "Gusto",
        category: "hr",
        description: "Payroll and team records.",
    },
    {
        id: "rippling",
        label: "Rippling",
        category: "hr",
        description: "HR, IT, and payroll records.",
    },
    {
        id: "deel",
        label: "Deel",
        category: "hr",
        description: "Global payroll and contractor records.",
    },
    {
        id: "bamboohr",
        label: "BambooHR",
        category: "hr",
        description: "Employee records and time off.",
    },
];
/**
 * Planned connectors that are still open for request — i.e. not yet present in
 * `CONNECTOR_CATALOG`. `catalogIds` is injectable for tests; the default is the
 * live catalog, so a connector PR merging automatically retires its planned row.
 */
export function listRequestableConnectors(catalogIds = new Set(CONNECTOR_CATALOG.map((entry) => entry.id))) {
    return PLANNED_CONNECTORS.filter((planned) => !catalogIds.has(planned.id));
}
//# sourceMappingURL=planned.js.map